import {List, Record, Map} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import * as Models from './models';

export interface InstitutionOverviewStateProps {
    fetchingAll: boolean;
    didFetchAll: boolean;
    departments: Map<string, Models.Department>;
    openingHours?: List<Models.OpeningHour>;
    fetchingTabs: boolean;
    tabs: List<Models.Tab>;
    activeTab: string;
    birthdays: Models.Birthdays;
}
export class InstitutionOverviewState extends Record<InstitutionOverviewStateProps>({
    fetchingAll: false,
    didFetchAll: false,
    departments: Map(),
    openingHours: undefined,
    fetchingTabs: false,
    tabs: List(),
    activeTab: '',
    birthdays: new Models.Birthdays(),
}) {}

export default makeReducer<InstitutionOverviewState>(
    [
        match(
            Actions.fetchAll,
            state =>
                new InstitutionOverviewState({
                    fetchingAll: true,
                    activeTab: state.activeTab,
                }),
        ),
        match(Actions.fetchAllSuccess, state =>
            state.merge({
                fetchingAll: false,
                didFetchAll: true,
            }),
        ),
        match(Actions.fetchAllFailed, state =>
            state.merge({
                fetchingAll: false,
            }),
        ),
        match(Actions.fetchInstitutionDepartmentsSuccess, (state, {payload}) =>
            state.merge({
                departments: payload.departments,
            }),
        ),
        match(Actions.fetchInstitutionOpeningHoursSuccess, (state, {payload}) =>
            state.merge({
                openingHours: payload.openingHours,
            }),
        ),
        match(Actions.fetchTabs, state =>
            state.merge({
                fetchingTabs: true,
            }),
        ),
        match(Actions.fetchTabsSuccess, (state, {payload}) =>
            state.merge({
                fetchingTabs: false,
                tabs: payload.tabs,
                activeTab: state.activeTab || (payload.hasStarredGroups ? 'STAR' : 'GROUPS'),
            }),
        ),
        match(Actions.fetchTabsFailed, state =>
            state.merge({
                fetchingTabs: false,
            }),
        ),
        match(Actions.selectTab, (state, {payload}) =>
            state.merge({
                activeTab: payload.tabId,
            }),
        ),
        match(Actions.fetchBirthdaysSuccess, (state, {payload}) =>
            state.merge({
                birthdays: payload.birthdays,
            }),
        ),
        match(Actions.leave, () => new InstitutionOverviewState()),
    ],
    new InstitutionOverviewState(),
);
